window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('fieldset[data-fieldset-toggled]').length) {
    import('./_form-fieldset-toggle.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
